import { render, staticRenderFns } from "./EmptyShoppingCart.vue?vue&type=template&id=4fd2e435&scoped=true"
import script from "./EmptyShoppingCart.vue?vue&type=script&lang=js"
export * from "./EmptyShoppingCart.vue?vue&type=script&lang=js"
import style0 from "./EmptyShoppingCart.vue?vue&type=style&index=0&id=4fd2e435&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2e435",
  null
  
)

export default component.exports